'use client'
import {
  checkoutData,
  productDataFlat,
  purchaseData,
  subscriptionPurchaseData,
  userData
} from "./chunk-YYZTLMHX.mjs";
import {
  MIXPANEL_EVENTS
} from "./chunk-GV6APKL5.mjs";
import {
  CHECKOUT_DATA_COOKIE_NAME
} from "./chunk-T2NN7R53.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/trackers/mixpanel/index.ts
import { loadScriptAsync, removeItem } from "@wbk/utils";
var MixpanelTracker = class {
  constructor(_a) {
    /**
     * Init Mixpanel script
     * @returns void
     */
    this.init = () => {
      const canRun = typeof window !== "undefined" && !!this.token;
      if (!canRun)
        return;
      loadScriptAsync({
        id: this.token,
        target: "head",
        snippet: `(function (f, b) { if (!b.__SV) { var e, g, i, h; window.mixpanel = b; b._i = [];
      b.init = function (e, f, c) { function g(a, d) { var b = d.split(".");
      2 == b.length && ((a = a[b[0]]), (d = b[1])); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))); }; } var a = b;
      "undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel"); a.people = a.people || [];
      a.toString = function (a) { var d = "mixpanel"; "mixpanel" !== c && (d += "." + c);
      a || (d += " (stub)"); return d; }; a.people.toString = function () { return a.toString(1) + ".people (stub)"; };
      i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split( " ");
      for (h = 0; h < i.length; h++) g(a, i[h]); var j = "set set_once union unset remove delete".split(" ");
      a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
      a.push([e, call2]); }; } for ( var d = {}, e = ["get_group"].concat( Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++) b(j[c]); return d; };
      b._i.push([e, f, c]); }; b.__SV = 1.2; e = f.createElement("script"); e.type = "text/javascript"; e.async = !0;
      e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"; g = f.getElementsByTagName("script")[0]; g.parentNode.insertBefore(e, g); } })(document, window.mixpanel || []);`
      });
      mixpanel.init(this.token, this.config);
    };
    /**
     * Set device type
     */
    this.setDevice = () => {
    };
    this.setCookieConsent = () => {
    };
    this.pageView = () => {
    };
    this.signupEvent = (_0) => __async(this, [_0], function* ({ user }) {
      this.track("Signup - Signup Success", { email: user.email });
    });
    this.loginEvent = (_0) => __async(this, [_0], function* ({ user }) {
      this.track("Login - Login Success", { email: user.email });
    });
    this.setUser = (user) => __async(this, null, function* () {
      const data = yield userData(user);
      this.identify(data);
    });
    this.logoutEvent = () => {
      this.reset();
    };
    this.viewItemEvent = (props) => __async(this, null, function* () {
      const data = productDataFlat(props);
      this.track("Event Details - Page View", data);
    });
    this.viewItemListEvent = () => {
    };
    this.generateLeadEvent = (event) => {
      this.track("Event Details - Book Tickets Btn", event);
    };
    this.viewItemBook = (props) => {
      const data = productDataFlat(props);
      this.track("Book Page - Page View", data);
    };
    this.cartEvent = () => {
    };
    this.viewSummaryEvent = () => {
    };
    this.ticketsSummaryEvent = () => {
    };
    this.paymentSummaryEvent = () => {
    };
    this.beginCheckout = (props) => {
      const data = checkoutData(props);
      this.track("Book Page - Checkout Btn", data);
    };
    this.purchaseEvent = (payment) => __async(this, null, function* () {
      const data = purchaseData(payment);
      this.track("Payment Success", data.order);
      removeItem(CHECKOUT_DATA_COOKIE_NAME);
    });
    this.purchaseSubscriptionEvent = (props) => {
      const data = subscriptionPurchaseData(props);
      this.track("Payment Success", data.order);
      removeItem(CHECKOUT_DATA_COOKIE_NAME);
    };
    this.purchaseFailed = (props) => {
      const reason = props == null ? void 0 : props.reason;
      this.track("Payment Failed", { reason });
    };
    this.registerInterestEvent = () => {
    };
    this.newsletterEvent = () => {
    };
    this.shareEvent = () => {
    };
    this.trackEvent = (props) => {
      const canFire = props.tracker === "mixpanel" || MIXPANEL_EVENTS.includes(props.event);
      if (!canFire)
        return;
      this.track(props.event, props.data);
    };
    this.track = (event_name, properties) => {
      if (typeof mixpanel !== "undefined") {
        mixpanel.track(event_name, properties);
        if (this.config.debug) {
          console.log("mixpanel track:", { event_name, properties });
        }
      }
    };
    this.identify = (user) => {
      if (typeof mixpanel !== "undefined") {
        const safeUser = __spreadProps(__spreadValues({}, user), { access_token: null });
        mixpanel.identify(user._id);
        mixpanel.people.set(safeUser);
        if (this.config.debug) {
          console.log("mixpanel identify:", { user: safeUser });
        }
      }
    };
    this.reset = () => {
      if (typeof mixpanel !== "undefined") {
        mixpanel.reset();
      }
      if (this.config.debug) {
        console.log("mixpanel reset");
      }
    };
    var _b = _a, { token } = _b, config = __objRest(_b, ["token"]);
    this.token = token;
    this.config = __spreadValues({
      persistence: "localStorage"
    }, config);
    this.init();
  }
};

export {
  MixpanelTracker
};
//# sourceMappingURL=chunk-NVBFUOMY.mjs.map